let serverurl='http://admin.ehotelier.it/bnlocalproxy.php';


function getQueryParams(qs) {
    qs = qs.split("+").join(" ");
    let params = {},
        tokens,
        re = /[?&]?([^=]+)=([^&]*)/g;

    while (tokens = re.exec(qs)) {
        params[decodeURIComponent(tokens[1])]
            = decodeURIComponent(tokens[2]);
    }

    return params;
}

window.brandnamic_newsletterconfirm=function(config){
    let getvars=getQueryParams(document.location.search);
    this.config=config;
    if (typeof this.config.serverurl != 'undefined') serverurl=this.config.serverurl;
    this.init=function(){
        let myUrl=serverurl+'?'+(typeof brandnamicnlconfirm.config.test =='undefined' ? '' : 'test='+brandnamicnlconfirm.config.test+'&')+'path=newsletterconfirm&email='+getvars.email+'&hash='+getvars.hash+'&callback=?'
        jQuery.ajax({
            url: myUrl,
            dataType: 'json',
            context: this,
            success: function(data) {
                brandnamicnlconfirm=this;
                if (typeof(data.status)!='undefined' && data.status=='OK'){
                    if (typeof brandnamicnlconfirm.config.onsuccess != 'undefined'){
                        brandnamicnlconfirm.config.onsuccess();
                    }else{
                        jQuery(brandnamicnlconfirm.config.errorlayer).hide();
                        jQuery(brandnamicnlconfirm.config.successlayer).show();
                    }

                }else{
                    if (typeof brandnamicnlconfirm.config.onerror != 'undefined'){
                        brandnamicnlconfirm.config.onerror(data.message);
                    }else{
                        jQuery(brandnamicnlconfirm.config.errorlayer).show();
                        jQuery(brandnamicnlconfirm.config.successlayer).hide();
                    }

                }
            }
        });
    };
    let brandnamicnlconfirm=this;
    brandnamicnlconfirm.init();
};


// WEBPACK FOOTER //
// ./source/js/ehotelier/general/e-mail-validation.js